<main>
  <app-hero></app-hero>
  <app-services></app-services>
  <app-projects></app-projects>
  <app-about></app-about>
  <app-contact></app-contact>
</main>
